/* eslint-disable no-mixed-operators */
import {
  createStore, compose, Middleware, applyMiddleware,
} from 'redux';

export const initializeStore = (initialState: any, reducer: any, ...middlewares: Middleware[]) => {
  const middlewareEnhancer = applyMiddleware(...middlewares);
  const composeEnhancers = typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  return createStore(
    reducer,
    initialState,
    composeEnhancers(middlewareEnhancer),
  );
};

export default initializeStore;
